import { TradingOfferStatus } from '../../../types/TradingOffer';

type TradingOfferStatusConfig = {
  label: string;
  value: TradingOfferStatus;
  fill: string;
  style: string;
  icon: string;
};

const tradingOfferStatus: Record<TradingOfferStatus, TradingOfferStatusConfig> =
  {
    DRAFT: {
      label: 'Draft',
      value: 'DRAFT',
      style: 'text-light',
      fill: 'bg-light',
      icon: 'ni-draft',
    },
    PENDING: {
      label: 'Pending',
      value: 'PENDING',
      style: 'text-primary',
      fill: 'bg-primary',
      icon: 'ni-clock',
    },
    CANCELED: {
      label: 'Canceled',
      value: 'CANCELED',
      style: 'text-danger',
      fill: 'bg-danger',
      icon: 'ni-cross-circle',
    },
    ACTIVE: {
      label: 'Active',
      value: 'ACTIVE',
      style: 'text-primary',
      fill: 'bg-primary',
      icon: 'ni-activity',
    },
    ACCEPTED: {
      label: 'Accepted',
      value: 'ACCEPTED',
      style: 'text-success',
      fill: 'bg-success',
      icon: 'ni-check-circle',
    },
    REJECTED: {
      label: 'Rejected',
      value: 'REJECTED',
      style: 'text-danger',
      fill: 'bg-danger',
      icon: 'ni-cross-circle',
    },
    EXPIRED: {
      label: 'Expired',
      value: 'EXPIRED',
      style: 'text-secondary',
      fill: 'bg-secondary',
      icon: 'ni-clock',
    },
  };

export default tradingOfferStatus;
